import { pick } from 'lodash-es';
import { SIGN_UP } from './sign-up.actions';
import { SESSION } from '../session';

const INIT_STATE = {
  user: {},
  move: {},
};

export function SignUpReducer(state = INIT_STATE, { type, payload }) {
  switch (type) {
    case SIGN_UP.SET_INVITE_INFO:
      return {
        invite_token: payload.token,
        user: pick(payload, [
          'first_name',
          'last_name',
          'middle_name',
          'suffix_name',
          'email',
          'phone',
        ]),
        move: {
          date: payload.move_date,
          from_address: payload.from_address,
          to_address: payload.to_address,
        },
      };
    case SIGN_UP.SET_ADDRESSES:
      return {
        ...state,
        move: {
          ...state.move,
          ...pick(payload, ['from_address', 'to_address']),
        },
      };
    case SIGN_UP.SET_CREDENTIALS:
      return {
        ...state,
        user: {
          ...state.user,
          ...payload,
        },
      };
    case SIGN_UP.SET_INFO:
      return {
        ...state,
        user: {
          ...state.user,
          ...pick(payload, [
            'first_name',
            'last_name',
            'middle_name',
            'suffix_name',
            'cell_phone',
          ]),
        },
        move: {
          ...state.move,
          date: payload.move_date,
        },
      };
    case SESSION.SET:
    case SESSION.CLEAR:
      return INIT_STATE;
    default:
      return state;
  }
}
